<script setup>
import Panel from '../../common/Panel.vue';
import ProductCard from '@maison/components/product/ProductCard.vue';
import ProductPrice from '@phoenix/components/common/ProductPrice.vue';
import { computed } from 'vue';

const props = defineProps({
  panelId: {
    type: String,
    required: true,
  },
  panelTitle: {
    type: String,
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
  categoryTitle: {
    type: String,
    required: true,
  },
  categoryDescription: {
    type: String,
    required: true,
  },
});
const currentCountry = window.Phoenix.currentCountry;
const price = computed(() =>
  props.product.price && props.product.price[currentCountry] ? props.product?.price[currentCountry] : {}
);
const vat = computed(() => price.value.vatInformation ?? '');
</script>

<template>
  <panel :id="panelId" :title="panelTitle" class="new-reference-enquiry-panel" :data-cy="panelId">
    <template #content>
      <product-card
        horizontal
        show-reference
        show-vat
        picture-full
        small-price
        :name="product.name"
        :labels="product.labels"
        :collection="product.collection"
        :subtitle="product.subtitle"
        :image="product.image"
        :vat-information="vat"
        :reference="product.modelReference"
        :reference-text="product.referenceText"
        :sap-reference="product.sapReference"
        :url="product.url"
        :should-display-add-to-wishlist="false"
        :show-tags="false"
        :should-display-price="false"
        :tight="false"
      >
        <template v-if="price" #price>
          <product-price v-bind="price"></product-price>
        </template>
      </product-card>
      <div class="divider divider--md"></div>
      <div v-if="categoryTitle" class="text-bold mt-lg" v-html="categoryTitle"></div>
      <div v-if="categoryDescription" class="mt-base" v-html="categoryDescription"></div>
      <slot />
    </template>
  </panel>
</template>
